var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 49,
    viewBox: "0 0 144 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 48,
    transform: "translate(0.119141 0.925049)",
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4488 14.7317C50.4488 15.607 50.1865 16.3041 49.6614 16.8241C49.0648 17.4424 48.2874 17.7517 47.3316 17.7517C46.4163 17.7517 45.6381 17.4383 44.9982 16.8106C44.357 16.1833 44.0371 15.4055 44.0371 14.4774C44.0371 13.5489 44.357 12.7715 44.9982 12.1438C45.6381 11.5165 46.4163 11.2026 47.3316 11.2026C47.7858 11.2026 48.2206 11.2904 48.6334 11.4655C49.0462 11.641 49.3774 11.874 49.6251 12.1658L49.0677 12.7171C48.6479 12.2213 48.0699 11.9736 47.3316 11.9736C46.6641 11.9736 46.0869 12.2054 45.5997 12.6694C45.1125 13.1339 44.869 13.7362 44.869 14.4774C44.869 15.2185 45.1125 15.8209 45.5997 16.2854C46.0869 16.7494 46.6641 16.9812 47.3316 16.9812C48.0397 16.9812 48.6301 16.7481 49.1028 16.2813C49.4096 15.9772 49.587 15.5544 49.6345 15.0116H47.3316V14.2586H50.4046C50.4343 14.4223 50.4488 14.5795 50.4488 14.7317Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.447 14.7317H50.3413C50.3405 15.587 50.0878 16.2514 49.5849 16.7502L49.5837 16.751L49.5833 16.7519C49.0057 17.3489 48.2633 17.646 47.3299 17.6472C46.439 17.646 45.6934 17.3456 45.0707 16.7367C44.4495 16.1266 44.1422 15.3818 44.1411 14.4774C44.1422 13.5726 44.4495 12.8282 45.0707 12.2185C45.6934 11.6092 46.439 11.3084 47.3299 11.3071C47.7704 11.3071 48.1899 11.3921 48.5899 11.5614C48.9904 11.732 49.3067 11.9556 49.5424 12.2332L49.6234 12.1658L49.5486 12.092L48.9912 12.6437L49.066 12.7172L49.1473 12.6503C48.708 12.1299 48.0913 11.8675 47.3299 11.8691C46.6376 11.8683 46.0286 12.1128 45.5249 12.5944C45.0163 13.0776 44.7607 13.7138 44.7616 14.4774C44.7607 15.241 45.0163 15.8772 45.5249 16.3604C46.0286 16.842 46.6376 17.0865 47.3299 17.0857C48.0615 17.0869 48.6849 16.8416 49.1758 16.3552C49.5036 16.0302 49.6894 15.5802 49.7381 15.0206L49.748 14.9071H47.4356V14.3631H50.4028V14.2586L50.2987 14.277C50.3277 14.4354 50.3413 14.5859 50.3413 14.7317H50.447H50.5527C50.5527 14.5729 50.5378 14.4097 50.5068 14.2399L50.4912 14.1541H47.2242V15.0116V15.1161H49.6328V15.0116L49.5275 15.0026C49.4809 15.5283 49.3116 15.9242 49.0263 16.2074C48.5722 16.6547 48.0149 16.8755 47.3299 16.8767C46.6871 16.8759 46.1417 16.6571 45.6715 16.2103C45.2058 15.765 44.9741 15.1965 44.973 14.4774C44.9741 13.7583 45.2058 13.1898 45.6715 12.7445C46.1417 12.2977 46.6871 12.0789 47.3299 12.0781C48.0446 12.0797 48.5842 12.3131 48.9851 12.7845L49.0594 12.8719L49.6981 12.2397L49.7666 12.172L49.7042 12.0989C49.4445 11.7928 49.0986 11.5499 48.6733 11.3696C48.2473 11.1888 47.7977 11.0982 47.3299 11.0982C46.3903 11.0973 45.5794 11.4238 44.9217 12.0699C44.2616 12.7148 43.9288 13.5253 43.9297 14.4774C43.9288 15.4291 44.2616 16.24 44.9221 16.8853C45.5794 17.531 46.3903 17.857 47.3299 17.8562C48.3084 17.857 49.1201 17.5358 49.736 16.8963L49.6596 16.8241L49.7343 16.8979C50.2818 16.3572 50.5535 15.6266 50.5527 14.7317H50.447Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3192 12.1133H52.4313V14.1008H55.0357V14.8541H52.4313V16.8417H55.3192V17.6118H51.6172V11.3432H55.3192V12.1133Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3194 12.113V12.0086H52.3259V14.2051H54.9302V14.7491L52.3259 14.7494V16.946H55.2138V17.5071H51.7231V11.4474H55.2138V12.113H55.3194V12.0086V12.113H55.4251V11.3429V11.2385H51.5117V17.7161H55.4251V16.8415V16.737H52.5372V14.9584H55.1416V14.1006V13.9961H52.5372V12.2175H55.4251V12.113H55.3194Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7565 17.6118H57.9411V12.1133H56.1699V11.3432H60.5277V12.1133H58.7565V17.6118Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7548 17.6116V17.5071H58.0451V12.0086H56.2739V11.4474H60.4203V12.0086H58.6491V17.6116H58.7548V17.5071V17.6116H58.8605V12.2175H60.6316V11.3429V11.2385H56.0625V12.113V12.2175H57.8337V17.7161H58.7548H58.8605V17.6116H58.7548Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6797 17.6118V11.3432H64.4943V17.6118H63.6797Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6799 17.6116H63.7856V11.4474H64.3888V17.5071H63.6799V17.6116H63.7856H63.6799V17.7161H64.4945H64.6002V11.2385H63.6799H63.5742V17.7161H63.6799V17.6116Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.108 17.6118H67.2926V12.1133H65.5215V11.3432H69.8791V12.1133H68.108V17.6118Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1082 17.6116V17.5071H67.3985V12.0086H65.6274V11.4474H69.7736V12.0086H68.0025V17.6116H68.1082V17.5071V17.6116H68.2139V12.2175H69.985V11.3429V11.2385H65.416V12.113V12.2175H67.1871V17.7161H68.1082H68.2139V17.6116H68.1082Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0807 16.2768C74.5501 16.7465 75.1244 16.9812 75.8036 16.9812C76.4827 16.9812 77.0574 16.7465 77.526 16.2768C77.9958 15.8071 78.2312 15.2066 78.2312 14.4774C78.2312 13.7481 77.9958 13.1477 77.526 12.678C77.0574 12.2082 76.4827 11.9736 75.8036 11.9736C75.1244 11.9736 74.5501 12.2082 74.0807 12.678C73.6121 13.1477 73.3768 13.7481 73.3768 14.4774C73.3768 15.2066 73.6121 15.8071 74.0807 16.2768ZM78.1288 16.8016C77.5053 17.4354 76.73 17.7517 75.8036 17.7517C74.8762 17.7517 74.1013 17.4354 73.4792 16.8016C72.8553 16.1686 72.5449 15.3936 72.5449 14.4774C72.5449 13.5611 72.8553 12.7861 73.4792 12.1532C74.1013 11.5193 74.8762 11.2026 75.8036 11.2026C76.7251 11.2026 77.4983 11.521 78.1247 12.1572C78.7501 12.7935 79.0631 13.5669 79.0631 14.4774C79.0631 15.3936 78.7509 16.1686 78.1288 16.8016Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0809 16.2768L74.0058 16.3503C74.4926 16.8388 75.0999 17.0869 75.8038 17.0857C76.5073 17.0869 77.1154 16.8388 77.6014 16.3503C78.0914 15.8613 78.3379 15.2287 78.3371 14.4774C78.3379 13.7261 78.0914 13.0935 77.6014 12.6045C77.1154 12.116 76.5073 11.8679 75.8038 11.8691C75.0999 11.8679 74.4926 12.116 74.0058 12.6045C73.517 13.0935 73.2701 13.7261 73.2713 14.4774C73.2701 15.2287 73.517 15.8613 74.0058 16.3503L74.0809 16.2768L74.1561 16.2034C73.7077 15.7523 73.4836 15.185 73.4827 14.4774C73.4836 13.7698 73.7077 13.2025 74.1561 12.7514C74.6086 12.3005 75.1489 12.0793 75.8038 12.0781C76.4581 12.0793 76.9998 12.3005 77.4511 12.7514C77.9003 13.2025 78.1245 13.7698 78.1253 14.4774C78.1245 15.185 77.9003 15.7523 77.4511 16.2034C76.9998 16.6543 76.4581 16.8755 75.8038 16.8767C75.1489 16.8755 74.6086 16.6543 74.1561 16.2034L74.0809 16.2768ZM78.129 16.8016L78.0534 16.729C77.4474 17.3428 76.7063 17.646 75.8038 17.6472C74.9009 17.646 74.1598 17.3428 73.5549 16.729L73.5521 16.7258L73.5549 16.729C72.9501 16.1131 72.6517 15.3704 72.6508 14.4774C72.6517 13.5844 72.9501 12.8417 73.5549 12.2258C74.1598 11.612 74.9009 11.3084 75.8038 11.3071C76.7005 11.3084 77.4399 11.6132 78.0493 12.2303C78.6562 12.849 78.9564 13.5906 78.9576 14.4774C78.9564 15.3704 78.657 16.1131 78.0534 16.729L78.129 16.8016L78.205 16.8742C78.8457 16.2237 79.1698 15.4169 79.169 14.4774C79.1698 13.5433 78.8444 12.738 78.2008 12.0846C77.5568 11.4287 76.7501 11.097 75.8038 11.0982C74.8526 11.097 74.0434 11.4272 73.4035 12.0806V12.0802C72.7615 12.731 72.4386 13.5379 72.4395 14.4774C72.4386 15.4169 72.7615 16.2237 73.4035 16.8746L73.4063 16.8776L73.4035 16.8742C74.0434 17.5276 74.8526 17.857 75.8038 17.8562C76.7546 17.857 77.5638 17.5276 78.205 16.8742L78.129 16.8016Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.207 17.6118V11.3432H81.1987L84.2807 16.2198H84.3158L84.2807 15.0117V11.3432H85.0961V17.6118H84.2456L81.0212 12.4989H80.9861L81.0212 13.7074V17.6118H80.207Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2073 17.6116H80.3129V11.4474H81.1403L84.2222 16.324H84.316H84.4245L84.3866 15.0099V11.4474H84.9906V17.5071H84.3045L81.08 12.3942H80.9863H80.8778L80.9157 13.7088V17.5071H80.2073V17.6116H80.3129H80.2073V17.7161H81.0214H81.1271V13.7055L81.092 12.4958L80.9863 12.4987V12.6031H81.0214V12.4987L80.9318 12.5542L84.1871 17.7161H85.0963H85.202V11.2385H84.2809H84.1752V15.0127L84.2103 16.2223L84.316 16.2195V16.115H84.2809V16.2195L84.3705 16.164L81.2575 11.2385H80.2073H80.1016V17.7161H80.2073V17.6116Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.353 35.3729H115.325V22.3119H113.353V35.3729ZM131.117 27.0168L128.856 32.6793H128.788L126.442 27.0168H124.318L127.836 34.9312L125.83 39.3336H127.888L133.31 27.0168H131.117ZM119.933 33.8894C119.286 33.8894 118.385 33.5702 118.385 32.7802C118.385 31.7721 119.508 31.3856 120.476 31.3856C121.344 31.3856 121.75 31.5704 122.278 31.8227C122.125 33.0324 121.071 33.8894 119.933 33.8894ZM120.17 26.731C118.742 26.731 117.264 27.353 116.652 28.7308L118.402 29.4532C118.776 28.7308 119.473 28.4953 120.204 28.4953C121.224 28.4953 122.261 29.1006 122.278 30.1759V30.3102C121.921 30.1086 121.156 29.8062 120.221 29.8062C118.334 29.8062 116.413 30.8309 116.413 32.7466C116.413 34.4942 117.96 35.6202 119.694 35.6202C121.02 35.6202 121.75 35.0321 122.21 34.3432H122.278V35.3512H124.181V30.3436C124.181 28.0252 122.431 26.731 120.17 26.731ZM107.982 28.6067H105.177V24.1297H107.982C109.456 24.1297 110.294 25.3364 110.294 26.3682C110.294 27.3803 109.456 28.6067 107.982 28.6067ZM107.931 22.3119H103.206V35.3729H105.177V30.4245H107.931C110.117 30.4245 112.266 28.8602 112.266 26.3682C112.266 23.8763 110.117 22.3119 107.931 22.3119ZM82.1628 33.8918C80.8003 33.8918 79.6596 32.7642 79.6596 31.2154C79.6596 29.6503 80.8003 28.5056 82.1628 28.5056C83.5079 28.5056 84.5636 29.6503 84.5636 31.2154C84.5636 32.7642 83.5079 33.8918 82.1628 33.8918ZM84.4273 27.7481H84.3591C83.9166 27.2264 83.0649 26.7551 81.9923 26.7551C79.7447 26.7551 77.6845 28.7075 77.6845 31.2154C77.6845 33.7066 79.7447 35.6422 81.9923 35.6422C83.0649 35.6422 83.9166 35.1708 84.3591 34.6325H84.4273V35.2721C84.4273 36.9723 83.5079 37.8812 82.0265 37.8812C80.8176 37.8812 80.0684 37.0225 79.7616 36.2989L78.0421 37.0058C78.5359 38.184 79.8471 39.6316 82.0265 39.6316C84.3422 39.6316 86.3004 38.2848 86.3004 35.0027V27.0245H84.4273V27.7481ZM87.6624 35.3729H89.6376V22.3115H87.6624V35.3729ZM92.5494 31.064C92.4982 29.347 93.8945 28.472 94.899 28.472C95.6828 28.472 96.3465 28.8589 96.5674 29.4148L92.5494 31.064ZM98.6791 29.5829C98.305 28.5896 97.1635 26.7551 94.8308 26.7551C92.5151 26.7551 90.5912 28.5561 90.5912 31.1987C90.5912 33.6898 92.4982 35.6422 95.0521 35.6422C97.1128 35.6422 98.305 34.3966 98.7986 33.673L97.266 32.6629C96.7556 33.4037 96.0569 33.8918 95.0521 33.8918C94.0476 33.8918 93.3326 33.4372 92.8727 32.5454L98.8831 30.0878L98.6791 29.5829ZM50.7924 28.1186V30.0037H55.3556C55.2194 31.064 54.8618 31.8382 54.3169 32.3769C53.653 33.0335 52.6143 33.7571 50.7924 33.7571C47.9828 33.7571 45.7864 31.5186 45.7864 28.7414C45.7864 25.9641 47.9828 23.7253 50.7924 23.7253C52.3079 23.7253 53.4144 24.3145 54.2318 25.072L55.5769 23.7424C54.4362 22.6649 52.9206 21.8402 50.7924 21.8402C46.9441 21.8402 43.709 24.9373 43.709 28.7414C43.709 32.5454 46.9441 35.6422 50.7924 35.6422C52.8699 35.6422 54.4362 34.9693 55.662 33.7066C56.9221 32.461 57.3139 30.7106 57.3139 29.2969C57.3139 28.8589 57.2799 28.4553 57.2114 28.1186H50.7924ZM62.5018 33.8918C61.1393 33.8918 59.9644 32.7809 59.9644 31.1987C59.9644 29.5997 61.1393 28.5056 62.5018 28.5056C63.8637 28.5056 65.0387 29.5997 65.0387 31.1987C65.0387 32.7809 63.8637 33.8918 62.5018 33.8918ZM62.5018 26.7551C60.0155 26.7551 57.9892 28.6234 57.9892 31.1987C57.9892 33.7571 60.0155 35.6422 62.5018 35.6422C64.9876 35.6422 67.0139 33.7571 67.0139 31.1987C67.0139 28.6234 64.9876 26.7551 62.5018 26.7551ZM72.345 33.8918C70.9831 33.8918 69.808 32.7809 69.808 31.1987C69.808 29.5997 70.9831 28.5056 72.345 28.5056C73.7071 28.5056 74.882 29.5997 74.882 31.1987C74.882 32.7809 73.7071 33.8918 72.345 33.8918ZM72.345 26.7551C69.8589 26.7551 67.833 28.6234 67.833 31.1987C67.833 33.7571 69.8589 35.6422 72.345 35.6422C74.8309 35.6422 76.8572 33.7571 76.8572 31.1987C76.8572 28.6234 74.8309 26.7551 72.345 26.7551Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4388 37.8694L11.3602 37.7951C11.0527 37.4734 10.8711 36.9739 10.8711 36.3271V36.4793V13.373C10.8711 13.371 10.8711 13.3694 10.8711 13.3677C10.8711 13.3697 10.8711 13.3714 10.8711 13.3735V13.5261C10.8711 12.8257 11.0828 12.2981 11.4375 11.9817L24.5324 24.926L11.4388 37.8694ZM10.8711 13.3665C10.8711 13.3089 10.8727 13.253 10.8756 13.1979C10.8727 13.2526 10.8711 13.3089 10.8711 13.3665ZM10.8756 13.1954C10.8756 13.1947 10.8756 13.1939 10.876 13.193C10.8756 13.1939 10.8756 13.1947 10.8756 13.1954ZM10.876 13.1881C10.876 13.1877 10.876 13.1873 10.876 13.1869C10.876 13.1873 10.876 13.1877 10.876 13.1881Z",
    fill: "url(#paint0_linear_1624_5421)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8975 29.395L28.9971 29.3391L34.1684 26.4345C34.6615 26.1575 34.9901 25.8216 35.154 25.4661C34.9905 25.8216 34.6618 26.1579 34.1684 26.435L28.9971 29.3395L28.8975 29.395ZM28.8988 29.242L24.5332 24.9258L28.8984 20.6103L34.1684 23.57C34.8377 23.9459 35.2134 24.4303 35.2762 24.9254C35.2762 24.9258 35.2762 24.9266 35.2762 24.9273C35.2134 25.4212 34.8377 25.9061 34.1684 26.2819L28.8988 29.242Z",
    fill: "url(#paint1_linear_1624_5421)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3725 38.3623C12.0067 38.3623 11.6875 38.2448 11.4386 38.0228L11.4391 38.0223C11.688 38.2443 12.0076 38.3623 12.3734 38.3623C12.4051 38.3623 12.4373 38.3615 12.47 38.3599C12.4369 38.3615 12.4042 38.3623 12.3725 38.3623ZM12.3729 38.2092C12.0071 38.2097 11.688 38.0917 11.4391 37.8697V37.8694L24.5327 24.926L28.8983 29.2421L13.557 37.8587C13.1325 38.0966 12.7304 38.2092 12.3729 38.2092ZM11.4354 38.0199C11.4122 37.9991 11.3895 37.9771 11.3672 37.9542L11.4354 38.0199Z",
    fill: "url(#paint2_linear_1624_5421)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5324 24.926L11.4375 11.9818C11.6864 11.7602 12.0052 11.6426 12.3705 11.6426C12.7289 11.6426 13.1314 11.7557 13.5567 11.994L28.8976 20.6106L24.5324 24.926ZM28.9963 20.5131L13.5567 11.8415C13.1314 11.603 12.7289 11.49 12.3705 11.49C12.3688 11.49 12.3677 11.49 12.366 11.49C12.3681 11.49 12.3697 11.49 12.3722 11.49C12.7298 11.49 13.1318 11.6026 13.5567 11.841L28.9963 20.5131Z",
    fill: "url(#paint3_linear_1624_5421)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8965 29.395L28.996 29.3391L28.8965 29.395Z",
    fill: "url(#paint4_linear_1624_5421)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3722 38.3623C12.0064 38.3623 11.6868 38.2443 11.4379 38.0223L11.4375 38.0228C11.4366 38.0219 11.4354 38.0208 11.4342 38.0199L11.366 37.9542C11.3639 37.9521 11.3619 37.9497 11.3594 37.9473L11.4379 37.8697C11.6868 38.0917 12.006 38.2097 12.3718 38.2092C12.7292 38.2092 13.1314 38.0966 13.5558 37.8587L28.8971 29.2421L28.9954 29.3393L28.8958 29.3952L13.5558 38.0114C13.169 38.228 12.8011 38.3411 12.4688 38.3599C12.4362 38.3615 12.4039 38.3623 12.3722 38.3623Z",
    fill: "url(#paint5_linear_1624_5421)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3602 37.9473C11.0527 37.6256 10.8711 37.1265 10.8711 36.4793V36.327C10.8711 36.9738 11.0527 37.4734 11.3602 37.795L11.4388 37.8693L11.3602 37.9473Z",
    fill: "url(#paint6_linear_1624_5421)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 37.9473L11.4379 37.8693V37.8696L11.3594 37.9473Z",
    fill: "url(#paint7_linear_1624_5421)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9967 29.3394L28.8984 29.2422L34.1681 26.2821C34.8373 25.9063 35.2131 25.4214 35.2758 24.9276C35.2758 25.1088 35.2349 25.29 35.1537 25.4664C34.9897 25.8218 34.6611 26.1577 34.1681 26.4348L28.9967 29.3394Z",
    fill: "url(#paint8_linear_1624_5421)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2763 24.9255C35.2135 24.4305 34.8377 23.9461 34.1685 23.5702L28.8984 20.6105L28.9967 20.5133H28.9972L34.1685 23.4179C34.9063 23.8326 35.2758 24.379 35.2763 24.9255Z",
    fill: "url(#paint9_linear_1624_5421)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8711 13.5261V13.3735C10.8711 13.3714 10.8711 13.3697 10.8711 13.3677C10.8711 13.3673 10.8711 13.3669 10.8711 13.3665C10.8711 13.3089 10.8727 13.2526 10.8756 13.198C10.8756 13.1971 10.8756 13.1963 10.8756 13.1955C10.8756 13.1947 10.8756 13.1939 10.876 13.193C10.876 13.1914 10.876 13.1898 10.876 13.1881C10.876 13.1877 10.876 13.1873 10.876 13.1869C10.9078 12.6298 11.0828 12.1952 11.3602 11.905L11.4375 11.9817C11.0828 12.2981 10.8711 12.8257 10.8711 13.5261ZM11.4354 11.832L11.4383 11.8291C11.4375 11.8303 11.4362 11.8312 11.4354 11.832Z",
    fill: "url(#paint10_linear_1624_5421)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8967 20.6104L13.5558 11.9938C13.1305 11.7555 12.7281 11.6424 12.3697 11.6424C12.0043 11.6424 11.6855 11.7599 11.4366 11.9815L11.3594 11.9049C11.3838 11.8796 11.4085 11.855 11.4345 11.8318C11.4354 11.831 11.4366 11.8302 11.4375 11.8293C11.6844 11.6094 11.9998 11.4919 12.3619 11.4898C12.3627 11.4898 12.3639 11.4898 12.3651 11.4898C12.3668 11.4898 12.368 11.4898 12.3697 11.4898C12.7281 11.4898 13.1305 11.6028 13.5558 11.8412L28.9954 20.5129L28.995 20.5132L28.8967 20.6104Z",
    fill: "url(#paint11_linear_1624_5421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1624_5421",
    x1: 23.3713,
    y1: 13.1293,
    x2: 5.8385,
    y2: 30.8657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1624_5421",
    x1: 36.0916,
    y1: 24.9264,
    x2: 10.5175,
    y2: 24.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1624_5421",
    x1: 26.5711,
    y1: 27.324,
    x2: 2.79531,
    y2: 51.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1624_5421",
    x1: 8.04344,
    y1: 4.21376,
    x2: 18.6603,
    y2: 14.9539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1624_5421",
    x1: 36.0906,
    y1: 24.9266,
    x2: 10.5164,
    y2: 24.9266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1624_5421",
    x1: 26.5699,
    y1: 27.324,
    x2: 2.79415,
    y2: 51.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1624_5421",
    x1: 23.3713,
    y1: 13.1292,
    x2: 5.83852,
    y2: 30.8657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1624_5421",
    x1: 26.5704,
    y1: 27.3243,
    x2: 2.7954,
    y2: 51.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1624_5421",
    x1: 36.0912,
    y1: 24.9266,
    x2: 10.5172,
    y2: 24.9266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1624_5421",
    x1: 36.0917,
    y1: 24.9266,
    x2: 10.5176,
    y2: 24.9266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1624_5421",
    x1: 23.3713,
    y1: 13.1293,
    x2: 5.83853,
    y2: 30.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1624_5421",
    x1: 8.04258,
    y1: 4.21353,
    x2: 18.6594,
    y2: 14.9537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.855b5437a49e1285ebf6db589cdac671.svg";
export { ForwardRef as ReactComponent };